module.exports = __webpack_public_path__ + "img/nexo.7309ac8b.svg";